<template>
  <div class="container-fluid bg-white">
    <div class="row">
      <div class="col-2 p-0">
        <Sidebar></Sidebar>
      </div>
      <div class="col-10">
        <div class="vh-100 overflow-scroll px-1">
          <Nav></Nav>
          <RouterView></RouterView>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Nav from "@/components/layouts/Nav";
import Sidebar from "@/components/layouts/Sidebar";
export default {
  components: {Sidebar, Nav}
}
</script>

<style lang="sass">

$primary :#7386D5
$danger : #f875a6
$success : #53B3AF
@import "~bootstrap/scss/bootstrap"
</style>